<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton title :row="20" :loading="loadingPage">

      <van-tabs v-model="active">
        <van-tab title="近期行程">
          <template v-if="isCalendar">
            <div v-if="data && data.length>0" class="courseList">
              <div class="title">选择需要预约的课程</div>
              <van-radio-group v-model="selectCourse" direction="horizontal" @change="onSelectCourseChange">
                <van-radio v-for="(item,index) in data" :key="index" :checked-color="GetColorMainBack()" :name="index">[{{ item.courseGroupTeam }}]{{ item.courseName }}</van-radio>
              </van-radio-group>
              <div class="remark">
                1.请务必确定您能够参加的课程，如不清楚，请联系客服人员;<br>
                2.预定细则请参考会员卡说明。
              </div>
            </div>
            <div v-if="data && data.length<=0" class="courseList">
              <div class="title">选择需要预约的课程</div>
              <div class="emptyLine">
                暂无可用行程,请联系客服或者稍后查看!
              </div>
            </div>
            <div v-if="selectCourse!==undefined" class="dateCalendarRect">
              <van-calendar
                ref="dateCalendar"
                title="日期选择"
                :poppable="false"
                :show-confirm="false"
                :style="{ height: '70vh' }"
                :min-date="dateBegin"
                :max-date="dateEnd"
                :color="GetColorMainBack()"
                :formatter="dateFormatter"
                @select="onDateSelect"
              />
            </div>
          </template>
          <template v-if="!isCalendar && dataBase">
            <div v-if="dataBase && dataBase.length > 30" class="searchRect">
              <van-field v-model="selectDateStr" readonly label="搜索日期" @click="showDateSelect=true">
                <template #button>
                  <van-button size="small" type="primary" :color="GetColorMain()" @click="showDateSelect=true">搜索</van-button>
                </template>
              </van-field>
            </div>
            <div v-if="dataBase.length<=0" class="courseList">
              <div class="emptyLine">
                暂无可用行程,请联系客服或者稍后查看!
              </div>
            </div>
            <div v-if="dataBase.length>0 && data.length<=0" class="courseList">
              <div class="emptyLine">
                当前日期无可用行程,请选择其他日期!
              </div>
            </div>
            <div v-for="item in data" :key="item.diveClassId" class="courseLineRect" :style="item ===selectValue?'border-color:'+GetColorMain()+';':'border-color:#fff;'" @click="onSelectSubscribe(item)">
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">行程</span>{{ item.courseName }}</van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">主教练</span>{{ item.coachName }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">队伍</span>{{ item.className }}</van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">出行日期</span>{{ item.dateStartStr }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">最大成员数</span>{{ item.fullNum }}</van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">可用成员数</span>
                  <template v-if="item.fullNum-item.memberNum>4">充足</template>
                  <template v-if="item.fullNum-item.memberNum<=4">{{ item.fullNum-item.memberNum }}</template>
                  <van-tag v-if="item.memberNum >= item.fullNum" type="primary" style="margin-left:1em;" :color="GetColorMain()">已满员</van-tag>
                </van-col>
              </van-row>
              <van-row gutter="20">
                <van-col v-if="item.memberCardCount > 1" span="12"><span :style="'color:'+GetColorMain()">多份预约</span>支持</van-col>
                <van-col span="12" />
              </van-row>

            </div>
          </template>
        </van-tab>
        <van-tab title="添加行程">
          <template v-if="!isCalendar && reserveList">
            <div class="courseList">
              <div class="title">待组队行程说明</div>
              <div class="aboutLine">
                1.您可以提前预约14-60天的行程，当满足开班最低人数需求后，我们将会尽力满足开班需求;<br>
                2.如开队失败，将会退回全部预交费用;<br>
                3.如没有符合要求的城市和队伍，可以自行创建并邀请朋友一同出行。<van-button type="primary" :color="GetColorMainBack()" size="mini" @click="onCreateReserve">创建队伍</van-button>
              </div>
            </div>

            <div v-if="reserveList.length<=0" class="courseList">
              <div class="emptyLine">
                暂无可用待组队行程,请联系客服或者稍后查看!
              </div>
            </div>
            <div v-for="item in reserveList" :key="item.reserve.reserveId" class="courseLineRect" :style="item ===selectReserve?'border-color:'+GetColorMain()+';':'border-color:#fff;'" @click="selectReserve = item">
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">行程</span>{{ item.product.className }}</van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">出行城市</span>{{ item.product.cityName }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">出行时间</span>{{ formatDate(item.reserve.startDate,"yyyy/MM/dd") }}</van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">预定时间</span>{{ formatDate(item.reserve.createDate,"yyyy/MM/dd hh:mm",true) }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">最大成员数</span>{{ item.reserve.maxPerson }}</van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">最小成员数</span>{{ item.reserve.minPerson }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">当前成员数</span>{{ item.reserve.personNow }}
                  <van-tag v-if="item.reserve.personNow >= item.reserve.maxPerson" type="primary" style="margin-left:1em;" :color="GetColorMain()">已满员</van-tag>
                </van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">结束时间</span>
                  <van-count-down
                    v-if="item.teamConfirmTime>0"
                    style=" display: inline-block;color:#000;"
                    :time="item.teamConfirmTime"
                    format="DD天HH时mm分"
                  />
                  <template v-if="item.teamConfirmTime<=0">即将结束</template>
                </van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12"><span :style="'color:'+GetColorMain()">预订人</span>{{ item.createUserName }}</van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()">费用</span>CNY {{ item.reserve.priceOne }}</van-col>
              </van-row>
              <van-row v-if="item.product.reamrk" gutter="20">
                <van-col span="24"><span :style="'color:'+GetColorMain()">备注</span>{{ item.product.reamrk }}</van-col>
              </van-row>
              <van-row v-if="item.product.about" gutter="20">
                <van-col span="24"><span :style="'color:'+GetColorMain()">介绍</span>{{ item.product.about }}</van-col>
              </van-row>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </van-skeleton>

    <div class="downEmpty" />
    <div class="downButton">
      <van-button
        square
        type="danger"
        :disabled="active===0?!selectDate:!selectReserve"
        size="large"
        :color="GetColorMain()"
        :loading-text="active===0?'预定中...':'加入队伍中...'"
        @click="onBook"
      >{{ active===0?'预定':'加入队伍' }}</van-button>
    </div>
    <van-popup v-model="showConfirmPage" position="bottom" class="confimRect">
      <van-nav-bar
        title="确认预约信息"
        right-text="返回"
        @click-right="showConfirmPage=false;selectDate=undefined;selectValue = undefined"
      />
      <div v-if="selectValue" class="infoRect">
        <div class="line">预约日期:<span :style="'color:'+GetColorMain()">{{ formatDate(selectDate,'yyyy/MM/dd') }}</span></div>
        <div class="line">主领队:<span :style="'color:'+GetColorMain()">{{ selectValue.coachName }}</span></div>
        <div v-if="selectValue.coachOtherNames" class="line">其他领队:<span :style="'color:'+GetColorMain()">{{ selectValue.coachOtherNames }}</span></div>
        <div class="line">队伍名称:<span :style="'color:'+GetColorMain()">{{ selectValue.className }}</span></div>
        <div class="line">最大成员数:<span :style="'color:'+GetColorMain()">{{ selectValue.fullNum }}</span></div>
        <div class="line">当前成员数:<span :style="'color:'+GetColorMain()">{{ selectValue.memberNum }}</span>
          <van-tag v-if="selectValue.memberNum >= selectValue.fullNum" type="primary" style="margin-left:1em;" :color="GetColorMain()">已满员</van-tag>
        </div>
        <div class="line lineStepper">预约人数:<span :style="'color:'+GetColorMain()">
          <van-stepper v-model="bookCount" min="1" :max="bookCountMax" theme="round" button-size="22" class="stepperSelectCount" disable-input /></span>
        </div>
        <div v-if="selectValue.memberCardTicketPrice>0" class="line">费用:<span :style="'color:'+GetColorMain()">CNY {{ selectValue.memberCardTicketPrice*bookCount }}</span></div>
        <van-checkbox v-model="confimBooking" style="margin-top:1em;" :checked-color="GetColorMain()">我已明确预约规则，一旦预定不可取消.</van-checkbox>

        <van-button square type="danger" size="middle" style="width:100%;margin-top:0.5em;" :color="GetColorMain()" :loading="buttonLoading" :disabled="selectValue.memberNum >= selectValue.fullNum" loading-text="预定中..." @click="onConfigBook">立即预定</van-button>

      </div></van-popup>
    <van-popup v-model="showReservePage" position="bottom" class="confimRect">
      <van-nav-bar
        title="确定加入待组队行程"
        right-text="返回"
        @click-right="showReservePage=false;selectReserve=undefined;"
      />
      <div v-if="selectReserve" class="infoRect">
        <div class="line">出行日期:<span :style="'color:'+GetColorMain()">{{ formatDate(selectReserve.reserve.startDate,'yyyy/MM/dd') }}</span></div>
        <div class="line">创建人:<span :style="'color:'+GetColorMain()">{{ selectReserve.createUserName }}</span></div>
        <div class="line">行程:<span :style="'color:'+GetColorMain()">{{ selectReserve.product.cityName }} {{ selectReserve.product.className }}</span></div>
        <div class="line">备注:<span :style="'color:'+GetColorMain()">{{ selectReserve.product.reamrk }}</span></div>
        <div class="line">最大成员数:<span :style="'color:'+GetColorMain()">{{ selectReserve.reserve.maxPerson }}</span></div>
        <div class="line">最小成员数:<span :style="'color:'+GetColorMain()">{{ selectReserve.reserve.minPerson }}</span></div>
        <div class="line">当前成员数:<span :style="'color:'+GetColorMain()">{{ selectReserve.reserve.personNow }}</span>
          <van-tag v-if="selectReserve.reserve.personNow >= selectReserve.reserve.maxPerson" type="primary" style="margin-left:1em;" :color="GetColorMain()">已满员</van-tag>
        </div>
        <div v-if="selectReserve.reserve.priceOne>0" class="line">费用:<span :style="'color:'+GetColorMain()">CNY {{ selectReserve.reserve.priceOne }}</span></div>
        <van-checkbox v-model="confimBooking" style="margin-top:1em;" :checked-color="GetColorMain()">我已明确预约规则，一旦预定不可取消.</van-checkbox>
        <van-button square type="danger" size="middle" style="width:100%;margin-top:0.5em;" :color="GetColorMain()" :loading="buttonLoading" :disabled="selectReserve.reserve.personNow >= selectReserve.reserve.maxPerson" loading-text="加入队伍中..." @click="onConfigReserve">立即加入队伍</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showDateSelect" position="bottom">
      <van-datetime-picker
        v-model="selectSearchDate"
        type="date"
        title="选择搜索日期"
        :min-date="minDate"
        @cancel="onCancelDateSearch"
        @confirm="onConfirmDateSearch"
      />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, RadioGroup, Radio, Skeleton, Calendar, Popup, NavBar, Checkbox, Tag, Tab, Tabs, CountDown, Field, DatetimePicker, Stepper } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Skeleton.name]: Skeleton,
    [Calendar.name]: Calendar,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CountDown.name]: CountDown,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Stepper.name]: Stepper,
    TopBar
  },
  data() {
    return {
      active: 0,
      isCalendar: false, // 是否日历模式
      titleTop: '',
      title: '行程预约',
      backurl: '/store/index',
      itemId: undefined,
      hashCode: undefined,
      data: undefined,
      dataBase: undefined,
      loadingPage: true,
      selectCourse: undefined,
      dateBegin: undefined,
      dateEnd: undefined,
      buttonLoading: false,
      needCleanSelect: false,
      selectDate: undefined,
      selectValue: undefined,
      showConfirmPage: false,
      confimBooking: false,
      reserveList: undefined,
      selectReserve: undefined,
      showReservePage: false,
      selectDateStr: undefined,
      showDateSelect: false,
      selectSearchDate: new Date(),
      minDate: new Date(),
      bookCount: 1,
      bookCountMax: 1
    }
  },
  created() {
    this.titleTop = GetSysTitle()
    this.itemId = getUrlKey('itemId')
    this.hashCode = getUrlKey('hashCode')
    if (getUrlKey('tab')) {
      this.active = parseInt(getUrlKey('tab'))
    }
    this.init()
    this.initReserveList()
  },
  methods: {
    MyNotify,
    getUrlKey,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onCancelDateSearch() {
      this.showDateSelect = false
      this.selectSearchDate = undefined
      this.selectDateStr = ''
      this.data = this.dataBase
    },
    onConfirmDateSearch() {
      this.showDateSelect = false
      if (this.selectSearchDate) {
        this.selectDateStr = formatDate(this.selectSearchDate, 'yyyy/MM/dd', false)
        this.data = this.dataBase.filter(el => el.dateStartStr === this.selectDateStr)
      } else {
        this.selectDateStr = ''
        this.data = this.dataBase
      }
    },
    init() {
      this.loadingPage = true
      request({
        url: '/MemberCard/GetMemberCardSubscribeList',
        method: 'post',
        params: { hashCode: this.hashCode,
          id: this.itemId }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        if (this.isCalendar) {
          this.data = response.data
        } else {
          var list = response.data
          this.dataBase = []
          list.forEach(course => {
            course.classList.forEach(el => {
              el.courseGroupTeam = course.courseGroupTeam
              el.courseName = course.courseName
              el.courseNameShort = course.courseNameShort
              el.courseTypeName = course.courseTypeName
              el.dateBegin = course.dateBegin
              el.dateEnd = course.dateEnd
              el.dt = new Date(el.dateStart)
              this.dataBase.push(el)
            })
          })
          this.dataBase = this.dataBase.sort((n1, n2) => {
            return n1.dt - n2.dt
          })
          this.data = this.dataBase
        }
      })
    },
    initReserveList() {
      this.reserveList = []
      request({
        url: '/MemberCard/getMemberCardReserveList',
        method: 'post',
        params: { id: this.itemId }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.reserveList = response.data
      })
    },
    onDateSelect(date) {
      console.log('onDateSelect', date)
      this.selectDate = date

      this.selectValue = undefined
      var config = this.data[this.selectCourse]
      var dayStr = formatDate(date, 'yyyy/MM/dd')
      var find = config.classList.filter(el => el.dateStartStr === dayStr)
      if (find.length > 0) {
        this.selectValue = find[0]
        this.onSelectSubscribeSetBookCount()
      }
    },
    onSelectCourseChange() {
      this.needCleanSelect = true
      this.selectDate = undefined
      setTimeout(() => {
        this.needCleanSelect = false
      }, 1)
      var config = this.data[this.selectCourse]
      this.dateBegin = new Date(config.dateBegin)
      this.dateEnd = new Date(config.dateEnd)
    },
    dateFormatter(day) {
      var config = this.data[this.selectCourse]
      var dayStr = formatDate(day.date, 'yyyy/MM/dd')
      var find = config.classList.filter(el => el.dateStartStr === dayStr)
      if (find.length > 0) {
        console.log(find[0])
        day.topInfo = find[0].coachName
        day.bottomInfo = '余位:' + (find[0].fullNum - find[0].memberNum)
        if (find[0].fullNum - find[0].memberNum <= 0) {
          day.type = 'disabled'
        }
      } else {
        day.type = 'disabled'
      }
      if (this.needCleanSelect && day.type === 'selected') {
        day.type = ''
        this.needCleanSelect = false
      }

      return day
    },
    onSelectSubscribe(item) {
      this.selectValue = item
      this.selectDate = item.dateStart
      this.onSelectSubscribeSetBookCount()
    },
    onSelectSubscribeSetBookCount() {
      if (this.selectValue) {
        console.log('this.selectValue', this.selectValue)
        this.bookCount = 1
        this.bookCountMax = 1
        var nowEmpty = this.selectValue.fullNum - this.selectValue.memberNum
        if (nowEmpty < this.selectValue.memberCardCount) {
          this.bookCountMax = nowEmpty
        } else {
          this.bookCountMax = this.selectValue.memberCardCount
        }
      }
    },
    onBook() {
      this.confimBooking = false
      if (this.active === 0) {
        this.showConfirmPage = true
      } else {
        this.showReservePage = true
      }
    },
    onConfigBook() {
      if (!this.confimBooking) {
        MyNotify('info', '请确认条款')
        return
      }
      this.buttonLoading = true
      request({
        url: '/MemberCard/MemberCardSubscribeAdd',
        method: 'post',
        data: { hashCode: this.hashCode,
          cardItemId: this.itemId,
          classId: this.selectValue.diveClassId,
          count: this.bookCount }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          MyNotify('success', '预定成功,请尽快完成支付')
          this.$router.push('/store/pay/0?id=' + response.data)
        } else {
          MyNotify('success', '预定成功')
          this.showConfirmPage = false
          this.showReservePage = false
        }
      })
    },
    onConfigReserve() {
      if (!this.confimBooking) {
        MyNotify('info', '请确认条款')
        return
      }
      this.buttonLoading = true
      request({
        url: '/MemberCard/MemberCardReserverJoin',
        method: 'post',
        data: { hashCode: this.hashCode,
          cardItemId: this.itemId,
          reserveId: this.selectReserve.reserve.reserveId }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          MyNotify('success', '加入队伍成功,请尽快完成支付')
          this.$router.push('/store/pay/0?id=' + response.data)
        } else {
          MyNotify('success', '加入队伍成功')
          this.showConfirmPage = false
          this.showReservePage = false
        }
      })
    },
    onCreateReserve() {
      this.$router.push('/memberCard/reserverAdd?itemId=' + this.itemId + '&hashCode=' + this.hashCode)
    }
  }
}
</script>
<style scoped>
.courseList{
  background-color: #fff;
  margin: 1em;
  padding: 1em;
  border-radius: 0.4em;
  font-size: 0.8em;
}
.courseList .title{
    font-weight: 700;
    font-size: 1.1em;
    padding: 0.5em 0;
}
.courseList .emptyLine{
  text-align: center;
  padding:3em 0;
}
.courseList .aboutLine{
  line-height: 1.8em;
}
.courseList .remark{
    color: #999;
    margin-top: 0.8em;
}
.downEmpty{
    height: 3em;
}
.downButton{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3em;
    line-height: 3em;
    background-color: #fff;
    border-top: 1px solid #f5f5f5;
}
.confimRect{
    color: #fff;
    border-top: 1px solid #f5f5f5;
    min-height: 30vh;
}
.infoRect{
    color: #000;
    padding: 1em;
    font-size: 0.8em;
}
.infoRect .line{
    padding: 0.25em 0;
}
.infoRect .line span{
    font-weight: 700;
    padding-left: 0.5em;
}

.courseLineRect{
  padding: 1em;
  margin: 1em;
  background-color: #fff;
  font-size: 0.8em;
  border-radius: 0.4em;
  border: 1px solid #fff;
}
.courseLineRect span{
  font-weight: 700;
  margin-right: 0.5em;
}
.lineStepper{
  line-height: 22px;
}
.stepperSelectCount{
  display: inline;

}
</style>
